/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { GroupUserRoleEnum } from '../models/GroupUserRoleEnum';
import { RequestStatus } from '../models/RequestStatus';
import { SimpleGroup } from '../models/SimpleGroup';
import { SimpleHorse } from '../models/SimpleHorse';
import { SimpleUser } from '../models/SimpleUser';
import { HttpFile } from '../http/http';

export class GroupInvite {
    'group': SimpleGroup;
    'id': number;
    'status'?: RequestStatus;
    'dtCreated': Date;
    'user'?: SimpleUser;
    'horse'?: SimpleHorse;
    'role'?: GroupUserRoleEnum;
    'text'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "group",
            "baseName": "group",
            "type": "SimpleGroup",
            "format": ""
        },
        {
            "name": "id",
            "baseName": "id",
            "type": "number",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "RequestStatus",
            "format": ""
        },
        {
            "name": "dtCreated",
            "baseName": "dtCreated",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "user",
            "baseName": "user",
            "type": "SimpleUser",
            "format": ""
        },
        {
            "name": "horse",
            "baseName": "horse",
            "type": "SimpleHorse",
            "format": ""
        },
        {
            "name": "role",
            "baseName": "role",
            "type": "GroupUserRoleEnum",
            "format": ""
        },
        {
            "name": "text",
            "baseName": "text",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return GroupInvite.attributeTypeMap;
    }

    public constructor() {
    }
}



